module.exports = __webpack_public_path__ + "static/057_nagl_widok_z_okna_walerii3-04fe86ef915dd729308afd75b0ddb2a6.jpg";